/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1CourseCourseidChannelsChannelid204,
  DeleteApiV1CourseCourseidChannelsChannelid400,
  DeleteApiV1CourseCourseidChannelsChannelid401,
  DeleteApiV1CourseCourseidChannelsChannelid404,
  DeleteApiV1CourseCourseidChannelsChannelid500,
  DeleteApiV1CourseCourseidChannelsChannelidMutationResponse,
  DeleteApiV1CourseCourseidChannelsChannelidPathParams,
} from "../../types/courseChannelsController/DeleteApiV1CourseCourseidChannelsChannelid.ts";

export const deleteApiV1CourseCourseidChannelsChannelidPathParamsSchema =
  z.object({
    courseId: z.coerce.number().int(),
    channelId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1CourseCourseidChannelsChannelidPathParams>;

/**
 * @description (No Content) Requisição não encontrou resultados.
 */
export const deleteApiV1CourseCourseidChannelsChannelid204Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidChannelsChannelid204>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const deleteApiV1CourseCourseidChannelsChannelid400Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidChannelsChannelid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1CourseCourseidChannelsChannelid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidChannelsChannelid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1CourseCourseidChannelsChannelid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidChannelsChannelid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1CourseCourseidChannelsChannelid500Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseCourseidChannelsChannelid500>;

export const deleteApiV1CourseCourseidChannelsChannelidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1CourseCourseidChannelsChannelid204Schema,
  ) as unknown as ToZod<DeleteApiV1CourseCourseidChannelsChannelidMutationResponse>;
